import { useState } from "react";

const THEME_KEY = "applecore_reader_theme";
const COLOR_KEY = "applecore_accent_color";
export const DEFAULT_ACCENT = "#ef4444";

export type ReaderTheme = "dark" | "light";

export function useReaderSettings() {
  const [theme, setThemeState] = useState<ReaderTheme>(() => {
    return (localStorage.getItem(THEME_KEY) as ReaderTheme) ?? "dark";
  });

  const [accentColor, setAccentColorState] = useState<string>(() => {
    return localStorage.getItem(COLOR_KEY) ?? DEFAULT_ACCENT;
  });

  const setTheme = (t: ReaderTheme) => {
    setThemeState(t);
    localStorage.setItem(THEME_KEY, t);
  };

  const setAccentColor = (c: string) => {
    setAccentColorState(c);
    localStorage.setItem(COLOR_KEY, c);
  };

  return { theme, setTheme, accentColor, setAccentColor };
}
